import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import Checkbox from '~/components/inputs/Checkbox/Checkbox';
import styles from './PaymentTermsPlus15Checkbox.module.scss';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  isDisabled?: boolean;
  className?: string;
}

/**
 * Presentational toggle for the EOM+15 payment terms. The owning form holds the
 * value and decides when to persist it (saved with the form, not on click).
 */
const PaymentTermsPlus15Checkbox: React.FC<Props> = ({ checked, onChange, isDisabled, className }) => {
  const { t } = useTranslation('documents', { keyPrefix: 'builder' });

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Checkbox checked={checked} isDisabled={isDisabled} onChange={onChange}>
        {t('fields.flow_date.plus15_toggle')}
      </Checkbox>
    </div>
  );
};

export default PaymentTermsPlus15Checkbox;
